const VALID_DEVICE_MEMORY_GB = [2, 4, 8, 16, 32] as const;

export function readDeviceMemoryOverride(): number | null {
  if (typeof window === 'undefined') return null;

  const raw = new URLSearchParams(window.location.search).get('deviceMemory');
  if (!raw) return null;

  const value = Number(raw);
  if (!Number.isFinite(value) || value <= 0) return null;

  const allowed = VALID_DEVICE_MEMORY_GB as readonly number[];
  if (!allowed.includes(value)) return null;

  return value;
}

export function readPerfLevelOverride(): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get('perfLevel')?.toLowerCase() ?? null;
}
